import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell, Container } from '@mantine/core';
import { Header } from '../components/common/Header';
import { Footer } from '../components/common/Footer';
import { useTheme } from '../contexts/ThemeContext';

export const MainLayout: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <AppShell
      header={{ height: 100 }}
      padding={0}
      styles={(theme) => ({
        main: {
          backgroundColor: isDarkMode ? theme.colors.dark[8] : theme.colors.gray[0],
          minHeight: '100vh',
          transition: 'background-color 0.2s ease',
        },
      })}
    >
      <Header />
      <Container size="xl" py="xl">
        <Outlet />
      </Container>
      <Footer />
    </AppShell>
  );
};